import { render, staticRenderFns } from "./PlayerLoginHistory.vue?vue&type=template&id=b4a3fb0e&"
import script from "./PlayerLoginHistory.vue?vue&type=script&lang=js&"
export * from "./PlayerLoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports